export default {
    booking: {
        reservations: {
            export: {
                atLeastOneService: "Please select at least one game",
            },
        },
    },
};
